import { Bem } from 'types/bem'
import { SortBemsType } from 'types/sortFunctions'
import { sortBems } from 'utils/sortFunctions'

interface FilterValues {
  vl_bem_inicial: number
  vl_bem_final: number
  vl_parcela_inicial: number
  vl_parcela_final: number
}
export default function filteredAndSortedBens(
  bensMaisDescontos: Bem[],
  filterValues: FilterValues,
  sortOption: keyof SortBemsType
) {
  const { vl_bem_final, vl_parcela_final, vl_parcela_inicial, vl_bem_inicial } = filterValues
  const filteredBens = bensMaisDescontos?.filter((bem: Bem) => {
    return (
      bem.vl_bem >= vl_bem_inicial &&
      bem.vl_bem <= vl_bem_final &&
      bem.vl_parcela >= vl_parcela_inicial &&
      bem.vl_parcela <= vl_parcela_final
    )
  })

  const sortedBems = filteredBens.sort(sortBems[sortOption])
  return sortedBems
}
